var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgAngleDown = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.633 1.405 1.981.083l4.058 4.03L10.143.178l1.324 1.345L6.015 6.75.633 1.405Z", fill: "currentColor" }));
export { SvgAngleDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTS42MzMgMS40MDUgMS45ODEuMDgzbDQuMDU4IDQuMDNMMTAuMTQzLjE3OGwxLjMyNCAxLjM0NUw2LjAxNSA2Ljc1LjYzMyAxLjQwNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
